import settingsKeys from "../settingsKeys";

const editSettingsResponder = (queryClient) => {
  return {
    onMutate: async ({ newSettings }) => {
      await queryClient.cancelQueries(settingsKeys.userSettings);

      const previousAllSettings = queryClient.getQueriesData(
        settingsKeys.userSettings
      );
      queryClient.setQueriesData(settingsKeys.userSettings, newSettings);

      // Return a context with the previous value
      return { previousAllSettings };
    },
    onSuccess: (returnedData) => {
      queryClient.setQueryData(settingsKeys.userSettings, returnedData);
    },
    onError: (error, _, { previousAllSettings }) => {
      // Rollback settings to previous state
      previousAllSettings.forEach(([key, value]) => {
        queryClient.setQueryData(key, value);
      });

      console.error("Failed to edit settings", error);
    },
  };
};

export default editSettingsResponder;
